export const ROUTER_HASH_TAGS_ENHANCEMENT = 'tags-enhancement';
export const ADD_TAGS_BUTTON_TEXT = 'Ajouter un tag';
export const PUBLICATION_DATE_FIELD_LABEL = 'Date & heure de publication';
